import React, { useEffect } from 'react';
import { html } from './Nucleo/CookiePolicy_gonucleo_EN_221108';
import { useDocumentTitle } from '../../../helpers/hooks';
import { BRANDING } from '../../../helpers/branding';
import { cookiePolicyIpls } from './IPLS/CookiePolicy_IPLS_EN';
import LegalContentFrame from './LegalContentFrame';

export default function CookiesPolicyPage() {
  useDocumentTitle('Cookies Policy');

  useEffect(() => {
    if (BRANDING === 'IPLS') {
      window.location.href = 'https://ipls.online/cookie-policy';
    }
  }, []);

  if (BRANDING === 'NUCLEO') {
    return <LegalContentFrame html={html} title="Privacy Policy" />;
  }
  
  return null;
}
